var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLaunchForm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7075_275594)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5895 0.901167C17.8498 1.14906 17.8445 1.55607 17.5776 1.81023L8.27301 10.6718C8.00613 10.9259 7.57878 10.931 7.31849 10.6831C7.0582 10.4352 7.06354 10.0282 7.33042 9.77405L16.635 0.912523C16.9019 0.658355 17.3292 0.653271 17.5895 0.901167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0886 0.984949C17.2696 1.15738 17.3283 1.41584 17.2396 1.64993L11.5712 16.6079C11.2226 17.5277 9.88252 17.5957 9.48038 16.714L6.78302 10.7998L0.573125 8.23086C-0.352709 7.84786 -0.281343 6.57162 0.684484 6.23964L16.3903 0.841095C16.6361 0.756607 16.9075 0.81252 17.0886 0.984949ZM1.65247 7.26286L7.42531 9.65097C7.67839 9.75566 7.87934 9.94704 7.98926 10.1881L10.4968 15.686L15.4915 2.50601L1.65247 7.26286Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7075_275594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchForm);
export default __webpack_public_path__ + "static/media/launch-form.22934882bff94c47c18b48b8e809b8f7.svg";
export { ForwardRef as ReactComponent };